import request from '../utils/request';
import type {
  LoginRequest,
  LoginResponse,
  TokenResponse,
  UserInfoResponse,
  TokenValidateResponse,
} from '../types';

export const authService = {
  // 用户登录
  login: (data: LoginRequest): Promise<LoginResponse> => {
    return request.post('/auth/login', data);
  },

  // 刷新令牌
  refresh: (): Promise<TokenResponse> => {
    return request.post('/auth/refresh');
  },

  // 获取当前用户信息
  getCurrentUser: (): Promise<UserInfoResponse> => {
    return request.get('/auth/me');
  },

  // 验证令牌
  validateToken: (): Promise<TokenValidateResponse> => {
    return request.get('/auth/validate');
  },

  // 登出
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_info');
  },
};
